import { FETCH_VIDEOS_DATA_SUCCEEDED, VideosAction } from '../actions/videosActions';
import { VideosState } from '../models/Videos';

const defaultState: VideosState = {
    data: [],
};

export const videos = (state: VideosState = defaultState, action: VideosAction) => {
    switch (action.type) {
        case FETCH_VIDEOS_DATA_SUCCEEDED:
            return {
                data: action.payload,
            };
        default:
            return state;
    }
};
